"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../index.scss");
const contexts_1 = require("@App/contexts");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const rightsholder_maintenance_schema_1 = require("@Entities/schemas/rightsholder/rightsholder-maintenance-schema");
const rightsholder_model_zod_mappers_1 = require("@App/helpers/rightsholder-model-zod-mappers");
const TopSection_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactEdit/TopSection"));
const AddressSection_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactEdit/AddressSection"));
const IdentifiersSection_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactEdit/IdentifiersSection"));
const ContactInfoSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserEdit/ContactInfoSection"));
const mobx_react_1 = require("mobx-react");
const convert_empty_values_to_undefined_1 = __importDefault(require("@App/forms/v2/helpers/convert-empty-values-to-undefined"));
const RightsholderMaintenanceContactEdit = (props) => {
    const { pending, setEditable, checkPending } = props;
    const { preloaderStore, popupStore, rightsholderStore, userStore, libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [rightsHolderData, setRightsHolderData] = (0, react_1.useState)({});
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        resolver: (0, zod_1.zodResolver)(rightsholder_maintenance_schema_1.rightsholderMaintenanceSchema),
    });
    (0, react_1.useEffect)(() => {
        setupRightsHolderData();
        return () => {
            setEditable(false);
        };
    }, []);
    const setupRightsHolderData = () => {
        const localMemberSummaryInfo = rightsholderStore.memberSummary;
        localMemberSummaryInfo.state = libStore.getStateFullName(localMemberSummaryInfo.country, localMemberSummaryInfo.state);
        const parsedData = (0, rightsholder_model_zod_mappers_1.rightsholderModelToZodMapper)(localMemberSummaryInfo);
        setRightsHolderData(parsedData);
    };
    (0, react_1.useEffect)(() => {
        initializeData();
    }, [rightsHolderData]);
    const initializeData = () => {
        // Sets up default values for form now that we have rightsholder data
        methods.reset(Object.assign({}, rightsHolderData));
    };
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (data) {
            try {
                preloaderStore.openTransparentPreloader(true);
                const updateData = (0, rightsholder_model_zod_mappers_1.zodToRightsholderModelMapper)(data);
                updateData.state = libStore.getStateFullName(updateData.country, updateData.state);
                yield rightsholderStore.editRightsholder(rightsholderStore.currentRightsholderId, (0, convert_empty_values_to_undefined_1.default)(updateData));
                checkPending();
                setEditable(false);
            }
            catch (error) {
                popupStore.setAlertFromError(error);
            }
            preloaderStore.openTransparentPreloader(false);
        }
    });
    const { name, extendedAddressForm, phoneNumber, hfaPublisherNumber, ipiNumber, isni, email } = rightsholder_maintenance_schema_1.rightsholderMaintenanceFormFields;
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit) },
            react_1.default.createElement("div", { className: "rightsholder-maintenance-contact-tab" },
                react_1.default.createElement(TopSection_1.default, { disabled: pending || userStore.isInternal || !methods.formState.isDirty, setNonEditable: () => setEditable(false), name: name }),
                react_1.default.createElement(AddressSection_1.default, { extendedAddressForm: extendedAddressForm }),
                react_1.default.createElement(IdentifiersSection_1.default, { hfaPublisherNumber: hfaPublisherNumber, isni: isni, ipiNumber: ipiNumber, rightsHolderData: rightsHolderData }),
                react_1.default.createElement(ContactInfoSection_1.default, { phoneNumberForm: phoneNumber, email: email })))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderMaintenanceContactEdit);
